/**
 * Granular per-user permissions.
 *
 * Stored on `users/{uid}` AND mirrored into the user's Firebase Auth custom
 * claims so Firestore + Storage rules can enforce without a lookup.
 *
 * Empty array means "no restriction" — i.e. the user inherits the role's defaults.
 * Use the `applyDefaults` helper to materialize the effective ID set.
 */
/** Default ID lists per role. Used when a user has no explicit overrides. */
export const ROLE_DEFAULT_PERMISSIONS = {
    admin: {
        allowedTileGroupIds: [],
        allowedSidebarItemIds: [],
        allowedTopActionIds: [],
        allowedTopicIds: [],
    },
    super_admin: {
        allowedTileGroupIds: [],
        allowedSidebarItemIds: [],
        allowedTopActionIds: [],
        allowedTopicIds: [],
    },
    inside_accountant: {
        allowedTileGroupIds: ['documents-group', 'bills-group', 'entities-group', 'sources-group', 'tools-group'],
        allowedSidebarItemIds: ['home', 'documents', 'bills', 'accounts', 'entities', 'assets', 'workspace', 'settings'],
        allowedTopActionIds: ['edit', 'ask', 'notes'],
        allowedTopicIds: ['dropbox', 'sharepoint', 'vos'],
    },
    outside_accountant: {
        allowedTileGroupIds: ['documents-group', 'entities-group', 'sources-group'],
        allowedSidebarItemIds: ['home', 'documents', 'entities', 'workspace'],
        allowedTopActionIds: ['ask', 'notes'],
        allowedTopicIds: ['sharepoint'],
    },
    lawyer: {
        allowedTileGroupIds: ['documents-group', 'entities-group', 'family-group'],
        allowedSidebarItemIds: ['home', 'documents', 'entities', 'workspace'],
        allowedTopActionIds: ['ask', 'notes'],
        allowedTopicIds: ['sharepoint'],
    },
    family_member: {
        allowedTileGroupIds: ['family-group', 'documents-group'],
        allowedSidebarItemIds: ['home', 'documents', 'assets', 'workspace'],
        allowedTopActionIds: ['ask', 'notes'],
        allowedTopicIds: [],
    },
    admin_assistant: {
        allowedTileGroupIds: ['bills-group', 'family-group'],
        allowedSidebarItemIds: ['home', 'bills', 'accounts', 'workspace'],
        allowedTopActionIds: ['ask', 'notes'],
        allowedTopicIds: ['dropbox'],
    },
    other: {
        allowedTileGroupIds: [],
        allowedSidebarItemIds: ['home'],
        allowedTopActionIds: ['notes'],
        allowedTopicIds: [],
    },
};
/** Filter a list of items by the user's effective allowedIds.
 *  Empty allowed list = no restriction (return everything). Admin role bypasses entirely upstream. */
export function filterByAllowed(items, allowedIds) {
    if (!allowedIds || allowedIds.length === 0)
        return items;
    const set = new Set(allowedIds);
    return items.filter((x) => set.has(x.id));
}
//# sourceMappingURL=permissions.js.map